/**
 * TanStack Query hooks for `ironsource-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	ironsourceIntegrationQueryKeys,
	type CreateIronsourceIntegrationBody,
	type ListIronsourceIntegrationResponse,
	type IronsourceIntegrationRow,
} from "./api";

export function useIronsourceIntegrationList(): UseQueryResult<ListIronsourceIntegrationResponse, Error> {
	return useQuery({
		queryKey: ironsourceIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useIronsourceIntegrationCreate(): UseMutationResult<IronsourceIntegrationRow, Error, CreateIronsourceIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ironsourceIntegrationQueryKeys.all });
		},
	});
}

export function useIronsourceIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ironsourceIntegrationQueryKeys.all });
		},
	});
}
